import { render, staticRenderFns } from "./UsersDetail.vue?vue&type=template&id=de066268&scoped=true"
import script from "./UsersDetail.vue?vue&type=script&lang=js"
export * from "./UsersDetail.vue?vue&type=script&lang=js"
import style0 from "./UsersDetail.vue?vue&type=style&index=0&id=de066268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de066268",
  null
  
)

export default component.exports